import styled from "styled-components";
import { colors, fontSizes, fontWeights, spacings } from "styles/theme";

interface TypeImageProps {
  highlight: boolean;
}

export const ImageInputWrapper = styled.div`
`

export const ImageInput = styled.input`
  display: none;
`

export const TypeImage = styled.span<TypeImageProps>`
  position: absolute;
  width: 100%;
  padding-top: ${spacings.xs};
  padding-left: ${spacings.md};
  font-weight: ${fontWeights.w700};
  font-size: ${fontSizes.xs};
  color: ${({highlight}) => highlight ? colors.secondary_four : colors.neutral_darkest};
`

export const ErrorText = styled.span`
  position: absolute;
  width: 100%;
  padding-top: ${spacings.md};
  padding-left: ${spacings.md};
  font-weight: ${fontWeights.w700};
  font-size: ${fontSizes.xs};
  color: ${colors.secondary_four}
`